import { render } from "./FavoritePageComponent.vue?vue&type=template&id=a3d63e34&scoped=true&ts=true"
import script from "./FavoritePageComponent.vue?vue&type=script&lang=ts"
export * from "./FavoritePageComponent.vue?vue&type=script&lang=ts"

import "./FavoritePageComponent.vue?vue&type=style&index=0&id=a3d63e34&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3d63e34"]])

export default __exports__